// Mock data for BEKÂR Music Group

export const artists = [
  // === REVEALED ARTISTS (Contracts Signed) ===
  {
    id: 5,
    name: "101 Flames of Inspiration",
    genre: "Global Collaboration",
    location: "Planet Earth",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/jghuo6kf_101%20Flames%20of%20Inspiration.jpg",
    featured: true,
    isRevealed: true,
    bio: "101 artists from around the world unite in this groundbreaking collaborative project, creating an immersive musical universe."
  },
  {
    id: 2,
    name: "Anny Ogrezeanu",
    genre: "Pop",
    location: "Germany",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/lzp3464v_Anny%20Ogrezeanu.jpg",
    featured: true,
    isRevealed: true,
    bio: "Winner of The Voice of Germany 2022, Anny Ogrezeanu crafts bold pop anthems about identity, dreams, and resilience."
  },
  {
    id: 4,
    name: "Maurice Kirya",
    genre: "Mwooyo",
    location: "Uganda",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/3dciuuql_Maurice%20Kirya.jpg",
    featured: true,
    isRevealed: true,
    bio: "Uganda's soul master Maurice Kirya blends traditional African sounds with contemporary soul in his unique Mwooyo style."
  },
  {
    id: 7,
    name: "Kerana & Kosmonavtite",
    genre: "Pop-Rock",
    location: "Bulgaria",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/ca6lufq2_Kerana.jpg",
    featured: true,
    isRevealed: true,
    bio: "Kerana & Kosmonavtite deliver powerful pop-rock performances with raw emotion and captivating stage presence."
  },
  {
    id: 8,
    name: "LÉLÉ",
    genre: "Pop",
    location: "Germany",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/vln3wvj3_LE%CC%81LE%CC%81.jpg",
    featured: true,
    isRevealed: true,
    bio: "LÉLÉ crafts contemporary pop with a fresh perspective and infectious melodies that resonate across generations."
  },
  {
    id: 11,
    name: "Tina Ruseva",
    genre: "Pop",
    location: "Germany / Macedonia",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/swrj02wq_Tina%20Ruseva.jpg",
    featured: true,
    isRevealed: true,
    bio: "Tina Ruseva bridges cultures with her pop sensibilities, bringing European flair to modern production."
  },
  {
    id: 22,
    name: "Tracy Merano",
    genre: "Pop",
    location: "Germany",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_c01822e4-5075-45e4-a0f9-c4ca496e5799/artifacts/88g4tpfx_Tracy%20Merano%20Photo.webp",
    featured: true,
    isRevealed: true,
    bio: "Tracy Merano delivers captivating pop with a unique artistic vision and mesmerizing visual aesthetics."
  },
  {
    id: 10,
    name: "YÀNA",
    genre: "Soul / R&B",
    location: "Bulgaria",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/zh85pw5n_YANA.jpg",
    featured: true,
    isRevealed: true,
    bio: "YÀNA's soulful voice and R&B stylings create an intimate atmosphere that connects deeply with listeners."
  },
  {
    id: 14,
    name: "Sophie Moser",
    genre: "Cinematic",
    location: "Germany",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/fej51pwa_Sophie%20Moser.jpg",
    featured: true,
    isRevealed: true,
    bio: "Sophie Moser creates sweeping cinematic soundscapes that transport listeners to otherworldly emotional landscapes."
  },
  {
    id: 13,
    name: "Laura Silverstone",
    genre: "Indie-Folk",
    location: "Scotland",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/gzkkkqho_Laura%20Silverstone.jpg",
    featured: true,
    isRevealed: true,
    bio: "Laura Silverstone weaves intricate indie-folk tales with acoustic intimacy and Scottish storytelling tradition."
  },
  {
    id: 17,
    name: "Plainride",
    genre: "Rock",
    location: "Austria",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_c01822e4-5075-45e4-a0f9-c4ca496e5799/artifacts/6v6cadwd_Plainride%20Photo.webp",
    featured: true,
    isRevealed: true,
    bio: "Plainride delivers powerful rock anthems with raw energy and an unmistakable vintage sound that commands attention."
  },
  {
    id: 18,
    name: "Makeda",
    genre: "Soul / R&B",
    location: "Germany",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_c01822e4-5075-45e4-a0f9-c4ca496e5799/artifacts/ucrcs55e_Makeda%20Photo.jpg",
    featured: true,
    isRevealed: true,
    bio: "Makeda captivates with her soulful voice and contemporary R&B stylings, weaving emotion into every note."
  },
  {
    id: 19,
    name: "Milen Kirov Quintet",
    genre: "Jazz",
    location: "Bulgaria",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_c01822e4-5075-45e4-a0f9-c4ca496e5799/artifacts/429vfpqt_Milen%20Kirov%20Quintet%20Photo.png",
    featured: true,
    isRevealed: true,
    bio: "Milen Kirov Quintet brings sophisticated jazz compositions with virtuoso piano work and dynamic ensemble interplay."
  },
  {
    id: 20,
    name: "Lind·Froot",
    genre: "Progressive World Music",
    location: "Germany",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_c01822e4-5075-45e4-a0f9-c4ca496e5799/artifacts/5qhx3hx4_Lind%C2%B7Froot%20Photo.jpg",
    featured: true,
    isRevealed: true,
    bio: "Lind·Froot is a vibrant collective with 20+ members curating its own genre - Progressive World Music."
  },
  {
    id: 21,
    name: "Alexander B.A. Pielsticker",
    genre: "Piano / Cinematic",
    location: "Germany",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_c01822e4-5075-45e4-a0f9-c4ca496e5799/artifacts/l6majfw6_Alexander%20B.A.%20Pielsticker%20Photo.jpg",
    featured: true,
    isRevealed: true,
    bio: "Alexander B.A. Pielsticker crafts unforgettable piano compositions packed in an outstanding immersive production."
  },
  {
    id: 16,
    name: "Angel Demirev",
    genre: "Fusion",
    location: "Bulgaria",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/40dr66t8_DEMIREV%20IV.jpg",
    featured: true,
    isRevealed: true,
    bio: "Angel Demirev pushes boundaries with innovative fusion music that blends genres and cultures seamlessly."
  },
  {
    id: 15,
    name: "Kamanzi",
    genre: "Soul",
    location: "Uganda",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/1jkftw81_Kamanzi.jpg",
    featured: true,
    isRevealed: true,
    bio: "Kamanzi's soulful artistry and authentic voice bring depth and emotion to every beautiful reality she creates."
  },
  {
    id: 24,
    name: "Pape Samory Seck",
    genre: "World Music",
    location: "Senegal",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_c01822e4-5075-45e4-a0f9-c4ca496e5799/artifacts/elhp0ex6_Pape%20Samory%20Seck.jpg",
    featured: true,
    isRevealed: true,
    bio: "Pape Samory Seck is a master of traditional Senegalese percussion, blending rich cultural heritage with contemporary world music."
  },
  // === UNREVEALED ARTISTS (Coming Soon) ===
  {
    id: 3,
    name: "Rema Diop",
    genre: "World",
    location: "Senegal",
    image: "https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/aqxr4bzi_Rema%20Diop.jpg",
    featured: false,
    isRevealed: false,
    bio: "Rema Diop brings the vibrant sounds of Senegal to global audiences with captivating world music."
  },
  {
    id: 23,
    name: "Carlou D",
    genre: "Afro-Folk",
    location: "Senegal",
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_c01822e4-5075-45e4-a0f9-c4ca496e5799/artifacts/hn8fgjt4_Carlou%20D.jpg",
    featured: false,
    isRevealed: false,
    bio: "Carlou D blends Senegalese traditions with folk and soul, creating a unique sound that transcends borders."
  }
];

export const ecoSystemServices = [
  {
    id: 1,
    title: "Music Production",
    description: "Cutting-edge immersive music production services for our roster, delivering world-class sound quality.",
    icon: "Music",
    color: "from-violet-500/20 to-purple-500/20"
  },
  {
    id: 2,
    title: "Label & Distribution",
    description: "Global distribution network ensuring your music reaches every corner of the world.",
    icon: "Disc3",
    color: "from-blue-500/20 to-cyan-500/20"
  },
  {
    id: 3,
    title: "Publishing & Sync",
    description: "Publishing agency offering sync licensing for film, TV, advertising, and gaming.",
    icon: "Film",
    color: "from-emerald-500/20 to-teal-500/20"
  },
  {
    id: 4,
    title: "Marketing & Promotion",
    description: "Strategic marketing campaigns that amplify your reach and build your fanbase.",
    icon: "TrendingUp",
    color: "from-orange-500/20 to-red-500/20"
  },
  {
    id: 5,
    title: "Photo & Video Production",
    description: "Professional visual content creation that captures your artistic vision.",
    icon: "Camera",
    color: "from-pink-500/20 to-rose-500/20"
  },
  {
    id: 6,
    title: "Management & Booking",
    description: "Artist development, career management, and booking on the world's best stages.",
    icon: "Users",
    color: "from-amber-500/20 to-yellow-500/20"
  }
];

export const newsArticles = [
  {
    id: 1,
    title: "Kamanzi Releases 'Beautiful Reality' with Stunning Video",
    excerpt: "A special journey months in the making - Kamanzi's latest release is a testament to authentic collaboration and artistic vision.",
    image: "https://static.wixstatic.com/media/2eed4c_29d575f052724923b0c778b885d37fd3~mv2.jpg",
    date: "2025-11-20",
    category: "Artist Release",
    fullContent: `Kamanzi's "Beautiful Reality" marks a significant milestone in the Ugandan soul artist's journey. This release represents months of dedicated work, bringing together authentic collaboration and pure artistic vision.

The accompanying music video, shot across stunning locations, perfectly captures the essence of the song's message - finding beauty in everyday moments and embracing life's journey with open arms.

Working closely with the BEKÂR production team, Kamanzi crafted a sound that stays true to his Ugandan roots while reaching for a global audience. The track blends soulful melodies with contemporary production, creating something truly special.

"This song is about seeing the world through grateful eyes," Kamanzi shares. "Every day we have the choice to see beauty around us, and I wanted to capture that feeling in both the music and the visuals."

The video features breathtaking cinematography that takes viewers on a visual journey, complementing the uplifting message of the track. From sunrise scenes to intimate performance shots, every frame was carefully crafted to enhance the emotional impact of the song.

"Beautiful Reality" is available now on all major streaming platforms.`
  },
  {
    id: 2,
    title: "Anny Ogrezeanu: From The Voice to Debut EP 'Dreams & Delusions (Vol. 1)'",
    excerpt: "The Voice of Germany winner makes bold moves as a solo artist, releasing their first EP exploring identity, ADHD, and being gender-queer.",
    image: "https://static.wixstatic.com/media/2eed4c_72e4320880394b518de4d342c4e6c0c4~mv2.jpg",
    date: "2025-10-10",
    category: "Artist Release",
    fullContent: `After winning The Voice of Germany in 2022, Anny Ogrezeanu has emerged as one of the most exciting new voices in German pop music. Their debut EP "Dreams & Delusions (Vol. 1)" showcases an artist unafraid to explore deeply personal themes.

The EP dives into Anny's experiences with identity, living with ADHD, and navigating the world as a gender-queer artist. Each track offers a window into their journey of self-discovery and acceptance.

"I wanted this EP to be honest," Anny explains. "These songs come from real experiences, real struggles, and real moments of joy. If someone listens and feels less alone, then I've done my job."

The production blends contemporary pop sensibilities with raw, emotional vocals that showcase Anny's incredible range. From upbeat anthems to introspective ballads, the EP demonstrates the versatility that made them stand out on The Voice.

Working with BEKÂR has allowed Anny to maintain creative control while accessing world-class production resources. The result is a debut that feels both polished and authentically personal.

"Dreams & Delusions (Vol. 1)" is just the beginning. Anny is already working on new material, promising more music that challenges conventions and celebrates individuality.

The EP is available now on all streaming platforms.`
  },
  {
    id: 3,
    title: "LĒN – A New Era of Storytelling Through the Voice of a Fierce Young Woman",
    excerpt: "From 'Kill The Heart' to 'Higher', Milena Tzanova's artistic journey unfolds with cinematic storytelling and emotional depth.",
    image: "https://static.wixstatic.com/media/2eed4c_1535ab746448470bb6c3b61747f6bf5e~mv2.png",
    date: "2025-09-15",
    category: "Artist Spotlight",
    fullContent: `LĒN, the artistic project of Milena Tzanova, represents a bold new chapter in cinematic pop storytelling. With releases like "Kill The Heart" and "Higher," she has established herself as an artist who refuses to play it safe.

Her music combines theatrical elements with deeply personal lyrics, creating an immersive experience that feels like stepping into a film. Each song tells a story, each video expands the narrative universe she's building.

"I've always been drawn to storytelling," Milena shares. "Music gives me the freedom to create worlds and characters, to explore emotions in ways that feel larger than life."

The visual component of LĒN's work is equally important. Her music videos are mini-films, carefully crafted to enhance the emotional journey of each song. The attention to detail in costumes, settings, and cinematography sets her apart in the modern pop landscape.

Working with BEKÂR's production and visual teams, LĒN has been able to realize her ambitious creative visions. From concept to final product, every element is considered and intentional.

"Higher" showcases her evolution as an artist - the production is bolder, the themes more mature, and the delivery more confident. It's the sound of an artist finding her voice and using it to full effect.

With more music on the horizon, LĒN continues to build her artistic universe, one powerful song at a time.`
  },
  {
    id: 4,
    title: "101 Flames of Inspiration – When a Spark Becomes a Universe",
    excerpt: "101 artists, dozens of cultures, GRAMMY® consideration, sold-out Dolby Atmos festival in Italy, and now a 3D planetarium show. This collaborative project has become something extraordinary.",
    image: "https://static.wixstatic.com/media/2eed4c_0552725521da4e6eac38d9909c720212~mv2.png",
    date: "2025-06-18",
    category: "Major Project",
    fullContent: `What started as an ambitious idea has grown into something extraordinary. "101 Flames of Inspiration" brings together 101 artists from dozens of cultures around the world, creating a collaborative musical experience unlike anything before.

The project has achieved remarkable milestones: GRAMMY® consideration, a sold-out Dolby Atmos festival in Italy, and now an immersive 3D planetarium show that takes audiences on a journey through sound and vision.

Each artist contributed their unique voice to the project, resulting in a tapestry of sounds that spans genres, languages, and traditions. From African rhythms to European electronic, from Asian melodies to American soul - the project celebrates the diversity of human musical expression.

"We wanted to show that music truly is a universal language," explains the project's creative team. "When you bring together artists from different backgrounds with open hearts and open minds, magic happens."

The Dolby Atmos mixing of the project takes the listening experience to another level. Sounds move around the listener, creating a three-dimensional soundscape that reveals new details with every listen.

The planetarium show, currently touring select venues, combines the music with stunning visuals projected across dome screens. Audiences lie back and let the experience wash over them - it's part concert, part meditation, part journey through the cosmos.

Volume 1 is available now, with more volumes planned as the project continues to grow. New artists are joining, new collaborations are forming, and the flames of inspiration continue to spread.

This is more than an album - it's a movement celebrating the power of collaboration and the universal language of music.`
  }
];

export const testimonials = [
  {
    id: 1,
    artist: "Kamanzi",
    quote: "I can't believe it's actually COME TO LIFE the way I'd envisioned it eons ago! Haven't quite experienced what I just experienced with my music before.",
    role: "Soul Artist"
  },
  {
    id: 2,
    artist: "Pape Samory Seck",
    quote: "The place where plans become a reality! The wonderful nature around the studios, the next-level productions, the team's energy and industry know-how... all of that brings me back here time after time.",
    role: "World Music Artist"
  },
  {
    id: 3,
    artist: "Plainride",
    quote: "Bob is a tremendous producer and a seriously gifted musician. If you're looking for Billboard-grade, high-end sound and a welcoming, professional, and inspiring work-environment for your next production, look no further.",
    role: "Rock Band"
  }
];
